import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { api, dataOf } from '../api'

export interface UserProfile { id: number; phone: string; creditBalance: number }

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('yc_token') || '')
  const user = ref<UserProfile | null>(null)
  const authenticated = computed(() => Boolean(token.value))

  function saveToken(value: string) {
    token.value = value
    localStorage.setItem('yc_token', value)
  }
  async function loadProfile() {
    if (!token.value) return null
    user.value = dataOf<UserProfile>(await api.get('/auth/me'))
    return user.value
  }
  function logout() {
    token.value = ''
    user.value = null
    localStorage.removeItem('yc_token')
  }
  return { token, user, authenticated, saveToken, loadProfile, logout }
})

